var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var defer = require('p-defer');

var Headers = require('./extract-headers');

var LteReader = require('./lte-reader');

function getPadding(size) {
  size &= 511;
  return size && 512 - size;
}

function discardPadding(_x, _x2) {
  return _discardPadding.apply(this, arguments);
}

function _discardPadding() {
  _discardPadding = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(reader, size) {
    var overflow;
    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            overflow = getPadding(size);

            if (!overflow) {
              _context5.next = 4;
              break;
            }

            _context5.next = 4;
            return reader.next(overflow);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));
  return _discardPadding.apply(this, arguments);
}

module.exports = function (options) {
  options = options || {};
  options.highWaterMark = options.highWaterMark || 1024 * 16;
  return function (source) {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var reader, gnuLongPath, gnuLongLinkPath, paxGlobal, pax, _loop, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ret;

      return _regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              reader = LteReader(source);
              _context4.prev = 1;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var headerBytes, _yield$_awaitAsyncGen, done, value, header, _yield$_awaitAsyncGen2, _done, gnuLongPathBytes, _yield$_awaitAsyncGen3, _done2, gnuLongLinkPathBytes, _yield$_awaitAsyncGen4, _done3, paxGlobalBytes, _yield$_awaitAsyncGen5, _done4, paxBytes, bytesRemaining, bodyConsumed, firstChunk, body, _;

                return _regeneratorRuntime.wrap(function _loop$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        headerBytes = void 0;
                        _context3.prev = 1;
                        _context3.next = 4;
                        return _awaitAsyncGenerator(reader.next(512));

                      case 4:
                        _yield$_awaitAsyncGen = _context3.sent;
                        done = _yield$_awaitAsyncGen.done;
                        value = _yield$_awaitAsyncGen.value;

                        if (!done) {
                          _context3.next = 9;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 9:
                        headerBytes = value;
                        _context3.next = 17;
                        break;

                      case 12:
                        _context3.prev = 12;
                        _context3.t0 = _context3["catch"](1);

                        if (!(_context3.t0.code === 'ERR_UNDER_READ')) {
                          _context3.next = 16;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 16:
                        throw _context3.t0;

                      case 17:
                        header = Headers.decode(headerBytes, options.filenameEncoding);

                        if (header) {
                          _context3.next = 20;
                          break;
                        }

                        return _context3.abrupt("return", "continue");

                      case 20:
                        if (!(header.type === 'gnu-long-path')) {
                          _context3.next = 32;
                          break;
                        }

                        _context3.next = 23;
                        return _awaitAsyncGenerator(reader.next(header.size));

                      case 23:
                        _yield$_awaitAsyncGen2 = _context3.sent;
                        _done = _yield$_awaitAsyncGen2.done;
                        gnuLongPathBytes = _yield$_awaitAsyncGen2.value;

                        if (!_done) {
                          _context3.next = 28;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 28:
                        gnuLongPath = Headers.decodeLongPath(gnuLongPathBytes, options.filenameEncoding);
                        _context3.next = 31;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 31:
                        return _context3.abrupt("return", "continue");

                      case 32:
                        if (!(header.type === 'gnu-long-link-path')) {
                          _context3.next = 44;
                          break;
                        }

                        _context3.next = 35;
                        return _awaitAsyncGenerator(reader.next(header.size));

                      case 35:
                        _yield$_awaitAsyncGen3 = _context3.sent;
                        _done2 = _yield$_awaitAsyncGen3.done;
                        gnuLongLinkPathBytes = _yield$_awaitAsyncGen3.value;

                        if (!_done2) {
                          _context3.next = 40;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 40:
                        gnuLongLinkPath = Headers.decodeLongPath(gnuLongLinkPathBytes, options.filenameEncoding);
                        _context3.next = 43;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 43:
                        return _context3.abrupt("return", "continue");

                      case 44:
                        if (!(header.type === 'pax-global-header')) {
                          _context3.next = 56;
                          break;
                        }

                        _context3.next = 47;
                        return _awaitAsyncGenerator(reader.next(header.size));

                      case 47:
                        _yield$_awaitAsyncGen4 = _context3.sent;
                        _done3 = _yield$_awaitAsyncGen4.done;
                        paxGlobalBytes = _yield$_awaitAsyncGen4.value;

                        if (!_done3) {
                          _context3.next = 52;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 52:
                        paxGlobal = Headers.decodePax(paxGlobalBytes, options.filenameEncoding);
                        _context3.next = 55;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 55:
                        return _context3.abrupt("return", "continue");

                      case 56:
                        if (!(header.type === 'pax-header')) {
                          _context3.next = 69;
                          break;
                        }

                        _context3.next = 59;
                        return _awaitAsyncGenerator(reader.next(header.size));

                      case 59:
                        _yield$_awaitAsyncGen5 = _context3.sent;
                        _done4 = _yield$_awaitAsyncGen5.done;
                        paxBytes = _yield$_awaitAsyncGen5.value;

                        if (!_done4) {
                          _context3.next = 64;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 64:
                        pax = Headers.decodePax(paxBytes, options.filenameEncoding);
                        if (paxGlobal) pax = _objectSpread(_objectSpread({}, paxGlobal), pax);
                        _context3.next = 68;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 68:
                        return _context3.abrupt("return", "continue");

                      case 69:
                        if (gnuLongPath) {
                          header.name = gnuLongPath;
                          gnuLongPath = null;
                        }

                        if (gnuLongLinkPath) {
                          header.linkname = gnuLongLinkPath;
                          gnuLongLinkPath = null;
                        }

                        if (pax) {
                          if (pax.path) header.name = pax.path;
                          if (pax.linkpath) header.linkname = pax.linkpath;
                          if (pax.size) header.size = parseInt(pax.size, 10);
                          header.pax = pax;
                          pax = null;
                        }

                        if (!(!header.size || header.type === 'directory')) {
                          _context3.next = 76;
                          break;
                        }

                        _context3.next = 75;
                        return {
                          header: header,
                          body: _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }))()
                        };

                      case 75:
                        return _context3.abrupt("return", "continue");

                      case 76:
                        bytesRemaining = header.size;
                        bodyConsumed = defer(); // Prefetch the first chunk.
                        // This allows us to stream entries for small files from the tar without
                        // explicitly streaming the body of each.

                        _context3.next = 80;
                        return _awaitAsyncGenerator(reader.nextLte(Math.min(bytesRemaining, options.highWaterMark)));

                      case 80:
                        firstChunk = _context3.sent;
                        bytesRemaining -= firstChunk.value.length;
                        if (!bytesRemaining) bodyConsumed.resolve();
                        body = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                          var _yield$_awaitAsyncGen6, _done5, _value;

                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.prev = 0;
                                  _context2.next = 3;
                                  return firstChunk.value;

                                case 3:
                                  if (!bytesRemaining) {
                                    _context2.next = 17;
                                    break;
                                  }

                                  _context2.next = 6;
                                  return _awaitAsyncGenerator(reader.nextLte(bytesRemaining));

                                case 6:
                                  _yield$_awaitAsyncGen6 = _context2.sent;
                                  _done5 = _yield$_awaitAsyncGen6.done;
                                  _value = _yield$_awaitAsyncGen6.value;

                                  if (!_done5) {
                                    _context2.next = 12;
                                    break;
                                  }

                                  bytesRemaining = 0;
                                  return _context2.abrupt("return");

                                case 12:
                                  bytesRemaining -= _value.length;
                                  _context2.next = 15;
                                  return _value;

                                case 15:
                                  _context2.next = 3;
                                  break;

                                case 17:
                                  _context2.prev = 17;
                                  bodyConsumed.resolve();
                                  return _context2.finish(17);

                                case 20:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2, null, [[0,, 17, 20]]);
                        }))();
                        _context3.next = 86;
                        return {
                          header: header,
                          body: body
                        };

                      case 86:
                        _context3.next = 88;
                        return _awaitAsyncGenerator(bodyConsumed.promise);

                      case 88:
                        if (!bytesRemaining) {
                          _context3.next = 116;
                          break;
                        }

                        _iteratorAbruptCompletion = false;
                        _didIteratorError = false;
                        _context3.prev = 91;
                        _iterator = _asyncIterator(body);

                      case 93:
                        _context3.next = 95;
                        return _awaitAsyncGenerator(_iterator.next());

                      case 95:
                        if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                          _context3.next = 100;
                          break;
                        }

                        _ = _step.value;

                      case 97:
                        _iteratorAbruptCompletion = false;
                        _context3.next = 93;
                        break;

                      case 100:
                        _context3.next = 106;
                        break;

                      case 102:
                        _context3.prev = 102;
                        _context3.t1 = _context3["catch"](91);
                        _didIteratorError = true;
                        _iteratorError = _context3.t1;

                      case 106:
                        _context3.prev = 106;
                        _context3.prev = 107;

                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                          _context3.next = 111;
                          break;
                        }

                        _context3.next = 111;
                        return _awaitAsyncGenerator(_iterator.return());

                      case 111:
                        _context3.prev = 111;

                        if (!_didIteratorError) {
                          _context3.next = 114;
                          break;
                        }

                        throw _iteratorError;

                      case 114:
                        return _context3.finish(111);

                      case 115:
                        return _context3.finish(106);

                      case 116:
                        _context3.next = 118;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 118:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _loop, null, [[1, 12], [91, 102, 106, 116], [107,, 111, 115]]);
              });

            case 3:
              if (!true) {
                _context4.next = 12;
                break;
              }

              return _context4.delegateYield(_loop(), "t0", 5);

            case 5:
              _ret = _context4.t0;

              if (!(_ret === "continue")) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("continue", 3);

            case 8:
              if (!(typeof _ret === "object")) {
                _context4.next = 10;
                break;
              }

              return _context4.abrupt("return", _ret.v);

            case 10:
              _context4.next = 3;
              break;

            case 12:
              _context4.prev = 12;
              _context4.next = 15;
              return _awaitAsyncGenerator(reader.return());

            case 15:
              return _context4.finish(12);

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee3, null, [[1,, 12, 16]]);
    }))();
  };
};